<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<ng-container *ngIf="model && model.content" [kitComponent]="model.content"></ng-container>

<!-- Load Button: 
<div class="kit-button-container">
  <ng-container [kitComponent]="model.content" kitComponentClass="kit-button-content"></ng-container>
  <div *ngIf="model.isLoading" class="kit-load-spinner"></div>
</div> 
-->